import {openSecuritySection} from './adapter';

/**
 * Canvas-wide WIDS/WIPS, on the Security tab of Canvas Settings.
 *
 * One of each setting, so nothing is resolved. Individual settings are
 * reached by the field path the catalogue declares; this plugin only owns
 * the tab itself.
 */
const securityPlugin = {
	id: 'security',
	version: 1,
	commandVersion: 1,
	resource: 'security',
	operations: ['options', 'view', 'configure'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['settings.security'],
	},
	sections: {
		'settings.security': openSecuritySection,
	},
};

export default securityPlugin;
